module.exports = __webpack_public_path__ + "static/media/logo_min_uno_branco.55d24c77.svg";